import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../GlobalContext';

const DaftarAngsuran = () => {
  const { periode, api, bulan } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    tanggal: new Date().toISOString().split('T')[0],
    piutang: 'D', // C, D, A — default to D to match Laporan Harian
  });
  const [angsuranData, setAngsuranData] = useState([]);
  const [message, setMessage] = useState('');

  // Fetch data angsuran based on filters
  const fetchAngsuranData = async () => {
    setLoading(true);
    setMessage('');
    try {
      /*const endpoint = formData.piutang === 'A'
        ? `/api/laporan/angsuran2/${formData.tanggal}/${formData.tanggal}/${formData.piutang}`
        : `/api/laporan/angsuran/${formData.tanggal}/${formData.tanggal}/${formData.piutang}`;*/
      
      const endpoint = `/api/laporan/angsuran2/${formData.tanggal}/${formData.tanggal}/${formData.piutang}`;

      const response = await api.get(endpoint);
      
      if (response.data) {
        // Handle both response structures: direct array or wrapped in {data}
        const dataArray = Array.isArray(response.data)
          ? response.data
          : (Array.isArray(response.data.data) ? response.data.data : []);
        
        setAngsuranData(dataArray);
      }
    } catch (error) {
      console.error('Error fetching angsuran data:', error);
      setMessage('Gagal mengambil data angsuran. Silakan coba lagi.');
      setAngsuranData([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle search/filter
  const handleSearch = (e) => {
    e.preventDefault();
    fetchAngsuranData();
  };

  // Auto-fetch when tanggal or piutang changes (and on mount)
  useEffect(() => {
    fetchAngsuranData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.tanggal, formData.piutang]);

  // Helpers
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    }).format(value || 0);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
    }).format(Number(value) || 0);
  };

  const parsePeriode = (p) => {
    if (!p) return null;
    const raw = String(p);
    const monthNames = bulan || ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
    const regexNames = new RegExp(`(${monthNames.join('|')})\\s+(\\d{4})`, 'i');
    const m = raw.match(regexNames);
    if (m) {
      const monthIndex = monthNames.findIndex(b => b.toLowerCase() === m[1].toLowerCase());
      return { month: monthIndex, year: parseInt(m[2], 10) };
    }
    // Try MM/YYYY or YYYYMM
    const m2 = raw.match(/(\d{1,2})[\\/\-](\d{4})/);
    if (m2) {
      return { month: parseInt(m2[1], 10) - 1, year: parseInt(m2[2], 10) };
    }
    const m3 = raw.match(/(\d{4})(\d{2})/);
    if (m3) {
      return { month: parseInt(m3[2], 10) - 1, year: parseInt(m3[1], 10) };
    }
    return null;
  };

  const isSamePeriode = (tanggal) => {
    if (!tanggal || !periode) return false;
    const p = parsePeriode(periode);
    if (!p) return false;
    const d = new Date(tanggal);
    if (isNaN(d.getTime())) return false;
    return d.getMonth() === p.month && d.getFullYear() === p.year;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const totalAngsuran = angsuranData.reduce((sum, row) => sum + (parseFloat(row.angsuran) || 0), 0);
  const totalJasa = angsuranData.reduce((sum, row) => sum + (parseFloat(row.jasa) || 0), 0);
  const totalGermen = angsuranData.reduce((sum, row) => sum + (parseFloat(row.germen) || 0), 0);

  return (
    <div className="container-fluid mt-4">
      <div className="card" style={{ borderTop: '3px solid #17a2b8' }}>
        <div className="card-header" style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
          <h5 className="card-title mb-0">Daftar Angsuran</h5>
        </div>

        {/* Filter Section */}
        <div className="card-body">
          <form onSubmit={handleSearch}>
            <div className="row mb-3">
              <div className="col-md-3">
                <label htmlFor="tanggal" className="form-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Tanggal</label>
                <input
                  type="date"
                  className="form-control"
                  id="tanggal"
                  name="tanggal"
                  value={formData.tanggal}
                  onChange={handleInputChange}
                  style={{ fontSize: '14px' }}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="piutang" className="form-label" style={{ fontWeight: 'bold', fontSize: '14px' }}>Piutang</label>
                <select
                  className="form-control"
                  id="piutang"
                  name="piutang"
                  value={formData.piutang}
                  onChange={handleInputChange}
                  style={{ fontSize: '14px' }}
                >
                  <option value="C">Angsuran C</option>
                  <option value="D">Angsuran D</option>
                </select>
              </div>
              <div className="col-md-2" style={{ paddingTop: '31px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ fontSize: '14px' }}
                >
                  {loading ? 'Mencari...' : 'Cari'}
                </button>
              </div>
            </div>
          </form>

          {/* Message */}
          {message && (
            <div className="alert alert-info alert-dismissible fade show" role="alert" style={{ marginTop: '15px', fontSize: '14px' }}>
              {message}
            </div>
          )}

          {/* Data Table */}
          <div className="table-responsive mt-4">
            <table className="table table-bordered" style={{ fontSize: '14px', marginBottom: '0' }}>
              <thead>
                <tr style={{ backgroundColor: '#17a2b8', color: 'white', fontWeight: 'bold' }}>
                  <th style={{ width: '5%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>No.</th>
                  <th style={{ width: '12%', padding: '10px', borderColor: '#17a2b8' }}>Tanggal</th>
                  <th style={{ width: '13%', padding: '10px', borderColor: '#17a2b8' }}>No. Transaksi</th>
                  <th style={{ width: '10%', padding: '10px', borderColor: '#17a2b8' }}>No. Anggota</th>
                  <th style={{ width: '18%', padding: '10px', borderColor: '#17a2b8' }}>Nama Anggota</th>
                  <th style={{ width: '12%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Angsuran</th>
                  <th style={{ width: '10%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Jasa</th>
                  <th style={{ width: '10%', padding: '10px', textAlign: 'right', borderColor: '#17a2b8' }}>Germen</th>
                  <th style={{ width: '8%', padding: '10px', textAlign: 'center', borderColor: '#17a2b8' }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(angsuranData) && angsuranData.length > 0 ? (
                  angsuranData.map((row, index) => (
                    <tr key={index} style={{ borderColor: '#ddd' }}>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>{index + 1}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{formatDate(row.tanggal)}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.notransaksi || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.noanggota || '-'}</td>
                      <td style={{ padding: '8px', borderColor: '#ddd' }}>{row.nama || '-'}</td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.angsuran || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.jasa || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'right', borderColor: '#ddd' }}>
                        {formatNumber(row.germen || 0)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', borderColor: '#ddd' }}>
                        {isSamePeriode(row.tanggal) ? (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            title="Hapus"
                            onClick={async () => {
                              if (!row.notransaksi) return alert('Tidak ada nomor transaksi untuk dihapus.');
                              if (window.confirm('Yakin ingin menghapus transaksi ini?')) {
                                  try {
                                  await api.delete(`/api/piutang/angsuran/${row.notransaksi}`);
                                  alert('Data berhasil dihapus.');
                                  fetchAngsuranData();
                                } catch (err) {
                                  console.error('Hapus gagal:', err);
                                  alert('Tidak dapat menghapus: endpoint belum tersedia atau terjadi kesalahan.');
                                }
                              }
                            }}
                          >
                            <i className="fa fa-trash" />
                          </button>
                        ) : (
                          <span style={{ color: '#999' }}>-</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center" style={{ padding: '20px', color: '#999', borderColor: '#ddd' }}>
                      {loading ? 'Memproses data...' : 'Tidak ada data. Silakan gunakan filter untuk mencari data.'}
                    </td>
                  </tr>
                )}
                {Array.isArray(angsuranData) && angsuranData.length > 0 && (
                  <tr style={{ borderTop: '2px solid #17a2b8' }}>
                    <td colSpan="5" style={{ padding: '10px', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8', textAlign: 'center' }}>
                      Total:
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalAngsuran)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalJasa)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', borderColor: '#ddd', fontWeight: 'bold', color: '#17a2b8' }}>
                      {formatNumber(totalGermen)}
                    </td>
                    <td style={{ padding: '10px', borderColor: '#ddd' }} />
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DaftarAngsuran;
